<div class="screen">

  <div class="section-row">
    <p class="section-title">{{ 'mobileSimulator.actus.title' | translate }}</p>
    <button class="filter-chip" [class.filter-chip--active]="filterSites.length > 0" (click)="openFilter.emit()">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
        <path d="M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A1 1 0 0 0 18.95 4H5.04a1 1 0 0 0-.79 1.61z"/>
      </svg>
      {{ 'mobileSimulator.common.filtre' | translate }}
      <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
    </button>
  </div>

  <div class="timeline">
    @for (evt of filteredEvenements; track evt.id; let last = $last) {
      <div class="tl-item">

        <div class="tl-left">
          <div class="tl-dot" [attr.data-type]="evt.type"></div>
          @if (!last) { <div class="tl-line"></div> }
        </div>

        <div class="tl-content" [class.tl-content--last]="last">
          <div class="tl-header">
            <span class="tl-time">{{ timeOf(evt.offsetMin) }}</span>
            <span class="tl-badge" [attr.data-type]="evt.type">{{ evt.badge }}</span>
          </div>
          <p class="tl-message">{{ evt.message }}</p>
        </div>

      </div>
    }
  </div>

</div>